import PropTypes from "prop-types"
import React from "react"
import { css } from "@emotion/core"
import logoImg from "../images/logo.png"
import Color from "../components/style/Color"

const header = css `
  background-color: ${Color.MainColor};
  height: 48px;
  width:100%;
`

const headerWrap = css `
  max-width:960px;
  margin:0 auto;
  padding:8px 10px 0;
`

const headerText = css`
  padding:0;
  margin:0;
`

const logo = css`
  width: 120px;
  margin:0;
`

const Header = ({ siteTitle }) => (
  <header css={header}>
    <div css={headerWrap}>
      <h1 css={headerText}>
        <a href="https://min-study.com/"><img src={logoImg} css={logo} alt={siteTitle} /></a>
      </h1>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
